import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  LinearProgress,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import UserDetailsContext from "../../../../context/auth";
import MaterialSelect from "../../../../components/MasterSelect";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";

const AddPerformance = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const { user } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [PerformanceData, setperformanceData] = useState({
    performanceDate: new Date().toISOString().split("T")[0],
    employeeName: "",
    managerComments: "",
    strength: "",
    areaOfImprovements: "",
    FeedBack: "",
    period: "",
    performanceDate: "unchecked",
    // employeeNameStatus: 'unchecked',
    managerCommentsStatus: "unchecked",
    strengthStatus: "unchecked",
    areaOfImprovementsStatus: "unchecked",
    FeedBackStatus: "unchecked",
    periodStatus: "unchecked",
  });


  // const [resource, setResource] = useState({
  //     employeeName: []
  // });

  const [originalperformanceData, setoriginalperformanceData] = useState({
    employeeName: "",
    managerComments: "",
    strength: "",
    areaOfImprovements: "",
    FeedBack: "",
    period: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const decodeBase64Id = (base64Id) => {
    if (!base64Id || typeof base64Id !== "string") {
      console.error("Invalid Base64 input provided:", base64Id);
      return null;
    }

    try {
      const decodedString = atob(base64Id); // Decode the Base64 string
      const parts = decodedString.split(":"); // Split by delimiter (e.g., ":")

      if (parts.length < 2) {
        console.error(
          "Decoded string does not match expected format:",
          decodedString
        );
        return null;
      }

      return parts[1]; // Return the numeric part
    } catch (error) {
      console.error("Error decoding Base64 ID:", error);
      return null;
    }
  };

  const onPerformanceSubmit = async () => {
    const query = `
           mutation managerPerformance($id:String!
$manager_comments:String!
$performance_date:String!
$period:String!
$strength:String!
$area_of_improvements:String!
$Feedback:String!
$teamleader_id:String!){
  ManagerPerformanceComment(input:{
    id:$id
    managerComments:$manager_comments
    PerformanceDate:$performance_date
    period:$period
    strength:$strength
    areaOfImprovements:$area_of_improvements
    Feedback:$Feedback
    teamleaderId:$teamleader_id
  }){
    ManagerPerformance{
      id
      managerComments
      period
      performanceDate
      strength
      areaOfImprovements
      FeedBack
      teamleaderId
      user{
        firstName
        id
      }
    }
  }
}

        `;

    const val = {
      // id: decodeBase64Id(user?.id),
      id: user?.id,
      manager_comments: PerformanceData.managerComments,
      performance_date: new Date().toISOString().split("T")[0],
      period: PerformanceData.period,
      strength: PerformanceData.strength,
      area_of_improvements: PerformanceData.areaOfImprovements,
      Feedback: PerformanceData.FeedBack,
      teamleader_id: user?.teamleader ? user.teamleader : 1,
    };


    try {
      const response = await fetch(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables: val,
        }),
      });

      const data = await response.json();

      if (!response.ok || (data.errors && data.errors.length > 0)) {
        throw new Error(data.errors?.[0]?.message || "Something went wrong");
      }

      if (data) {
        navigate("/performance");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Performance Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("Error during submission:", error);

      setConfirmationDialog({
        open: true,
        title: "Error",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditPerformanceSubmit = async () => {
    setPageState({
      ...pageState,
      state: "submitting",
    });

    const query = `
          mutation UpdateManagerPerformance($input: updateperformanceInput!) {
  EditManagerPerformance(input: $input) {
    ManagerPerformance {
      id
      period
      managerComments
      performanceDate
      strength
      areaOfImprovements
      FeedBack
      teamleaderId
    }
  }
}

        `;

    let val = {
      id: PerformanceData.id, // Ensure this is the correct ID being passed
      period: PerformanceData.period, // Add missing fields as needed
      managerComments: PerformanceData.managerComments,
      performanceDate: PerformanceData.performanceDate,
      strength: PerformanceData.strength,
      areaOfImprovements: PerformanceData.areaOfImprovements,
      FeedBack: PerformanceData?.FeedBack,
      teamleaderId: PerformanceData.teamleaderId
        ? PerformanceData.teamleaderId
        : 1,
    };


    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              id: PerformanceData.id, // Ensure this is the correct ID being passed
              period: PerformanceData.period, // Add missing fields as needed
              managerComments: PerformanceData.managerComments,
              performanceDate: PerformanceData.performanceDate,
              strength: PerformanceData.strength,
              areaOfImprovements: PerformanceData.areaOfImprovements,
              FeedBack: PerformanceData.FeedBack,
              teamleaderId: PerformanceData.teamleaderId
                ? PerformanceData.teamleaderId
                : 1,
            },
          },
        }),
      });

      const responseData = response.data;


      // Check for errors in response data
      if (responseData.errors) {
        throw new Error(
          responseData.errors[0]?.message || "Something went wrong"
        );
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      navigate("/performance");
    } catch (error) {
      console.error("responseError:", error.response.data);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeletePerformance();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ondeletePerformance = async () => {
    const query = `
          mutation delete($id: String!) {
            DeleteManagerPerformancerequest(id: $id) {
              success
                
            }
          }
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id, // Ensure `id` is defined in your scope
        },
      });

      const responseData = response.data;


      // Ensure that the success flag is checked correctly
      if (responseData.data.DeleteManagerPerformancerequest.success) {
        navigate("/performance");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Performance Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
      }
    } catch (error) {
      console.error(
        "An error occurred while deleting the Performance:",
        error.response.data
      );
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });

    const query = `
          query getPerformanceById($id: String!) {
            getPerformanceById(id: $id) {
              id
              performanceDate
              employeeComments
              managerComments
              strength
              areaOfImprovements
              teamleaderId
              FeedBack
              period
              user {
                firstName
                
              }
            }
          }
        `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      // Check for errors in the response data
      if (response.data.errors) {
        throw new Error(
          response.data.errors[0]?.message || "Failed to fetch performance data"
        );
      }

      // Extract performance data from the response
      const performanceRowData = response.data.data.getPerformanceById;


      // Set performance data in state
      // setperformanceData({
      //     performanceDate: performanceRowData.performanceDate,
      //     employeeName: performanceRowData.employeeName,
      //     employeeComments: performanceRowData.employeeComments,
      //     managerComments: performanceRowData.managerComments,
      //     strength: performanceRowData.strength,
      //     period: performanceRowData.period,
      //     areaOfImprovements: performanceRowData.areaOfImprovements,
      //     FeedBack:performanceRowData.FeedBack
      // });

      setperformanceData(performanceRowData);

      // Set original performance data in state
      setoriginalperformanceData({
        performanceDate: performanceRowData.performanceDate,
        employeeName: performanceRowData.employeeName,
        employeeComments: performanceRowData.employeeComments,
        managerComments: performanceRowData.managerComments,
        strength: performanceRowData.strength,
        period: performanceRowData.period,
        areaOfImprovements: performanceRowData.areaOfImprovements,
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });

      // Update the page state to reflect data loading is complete
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        message:
          "We are unable to fetch the required data at this time. Please try again later. If the problem persists, please contact support.",
        state: "error",
      });
    }
  };

  const handleperformanceData = (event) => {
    // Clone the current state
    let performanceState = { ...PerformanceData };

    // Switch case for handling different input fields
    switch (event.target.name) {
      case "performanaceDate": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }

      case "employeeName": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "employeeComments": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "managerComments": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "strength": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "period": {
        const descriptionRegex = new RegExp("^([\\s\\S]{5,10})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "areaOfImprovements": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "FeedBack": {
        const descriptionRegex = new RegExp("^([\\s\\S]{20,500})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          performanceState[event.target.name + "Status"] = "success";
        } else {
          performanceState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }

    // Update the value of the field being modified
    performanceState[event.target.name] = event.target.value;

    setperformanceData(performanceState);
  };

  const handleAddPerformance = () => {
    setPageState({
      ...pageState,
      state: "submitting",
    });
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onPerformanceSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardPerformance = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setperformanceData({
      performanceDate: PerformanceData.performanceDate,
      employeeName: PerformanceData.employeeName,
      employeeComments: PerformanceData.employeeComments,
      managerComments: PerformanceData.managerComments,
      strength: PerformanceData.strength,
      period: PerformanceData.period,
      areaOfImprovements: PerformanceData.areaOfImprovements,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      // PerformanceData.employeeNameStatus === 'success' &&
      // PerformanceData.employeeCommentsStatus === 'success' &&
      PerformanceData.managerCommentsStatus === "success" &&
      PerformanceData.strengthStatus === "success" &&
      // PerformanceData.periodStatus === 'success' &&
      PerformanceData.areaOfImprovementsStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      // PerformanceData.employeeName === originalperformanceData.employeeName &&
      PerformanceData.managerComments ===
        originalperformanceData.managerComments &&
      PerformanceData.strength === originalperformanceData.strength &&
      PerformanceData.period === originalperformanceData.period &&
      PerformanceData.areaOfImprovements ===
        originalperformanceData.areaOfImprovements
    ) {
      allowSubmit = false;
    }
    // else if (PerformanceData.employeeName !== originalperformanceData.employeeName) {
    //     if (PerformanceData.employeeNameStatus === 'success') {
    //         allowSubmit = true
    //     }
    //     else {
    //         allowSubmit = false
    //     }
    // }
    else if (
      PerformanceData.managerComments !==
      originalperformanceData.managerComments
    ) {
      if (PerformanceData.managerCommentsStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (PerformanceData.strength !== originalperformanceData.strength) {
      if (PerformanceData.strengthStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (PerformanceData.period !== originalperformanceData.period) {
      if (PerformanceData.periodStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      PerformanceData.areaOfImprovements !==
      originalperformanceData.areaOfImprovements
    ) {
      if (PerformanceData.areaOfImprovementsStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Performance details for you.
                    This may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Performance Detail
                      </MaterialTypography>
                    </Stack>
                    {pageState.state !== "submitting" && (
                      <ButtonGroup
                        variant="outlined"
                        aria-label="Loading button group"
                      >
                        <MaterialButton
                          variant="contained"
                          color="dark"
                          onClick={toggleEdit}
                          startIcon={<EditIcon />}
                        >
                          Edit
                        </MaterialButton>
                        <MaterialButton
                          variant="contained"
                          color="dark"
                          onClick={AddDelete}
                          startIcon={<DeleteIcon />}
                        >
                          delete
                        </MaterialButton>
                      </ButtonGroup>
                    )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Performance
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Performance Date*
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="performanceDate"
                      value={new Date().toISOString().slice(0, 10)}
                      readOnly
                      error={PerformanceData.performanceDateStatus === "error"}
                      success={
                        PerformanceData.performanceDateStatus === "success"
                      }
                      disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                  {/* <Grid size={{ xs: 6, sm: 6 }}>
                                                <MaterialBox lineHeight={0} display="inline-block">
                                                    <MaterialTypography
                                                        component="label"
                                                        variant="caption"
                                                        fontWeight="bold"
                                                    >
                                                        Employee Name
                                                    </MaterialTypography>
                                                </MaterialBox>
                                                <MaterialSelect
                                                    name="employeeName"
                                                    value={PerformanceData.departmentName}
                                                    customStyles={{ optionPadding: 20 }}
                                                    // onChange={handleDesignationDatachange} //selectedValue, event
                                                    options={resource.PerformanceData.map((value) => {
                                                        return {
                                                            value: value.id,
                                                            label: value.employeeName
                                                        }
                                                    })}
                                                    // options={departmentOptions}
                                                    error={PerformanceData.employeeNameStatus === "error" ? true : false}
                                                    success={PerformanceData.employeeNameStatus === "success" ? true : false}
                                                    isClearable
                                                    disabled={togglePage.view === true ? true : false}
                                                />
                                            </Grid> */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Period*
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="period"
                      placeholder="eg. Half-Yearly"
                      value={PerformanceData.period}
                      onChange={handleperformanceData}
                      error={PerformanceData.periodStatus === "error"}
                      success={PerformanceData.periodStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                    {PerformanceData.periodStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Period should be a minimum 5 characters maximum 10
                          characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Manager Comments*
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="managerComments"
                      placeholder="eg.Manager Comments"
                      value={PerformanceData.managerComments}
                      onChange={handleperformanceData}
                      error={PerformanceData.managerCommentsStatus === "error"}
                      success={
                        PerformanceData.managerCommentsStatus === "success"
                      }
                      disabled={togglePage.view === true ? true : false}
                      multiline
                      rows={5}
                    />
                    {PerformanceData.managerCommentsStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          manager Comments Status should be a minimum 20
                          characters maximum 500 characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Strength*
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="strength"
                      placeholder="eg. strength"
                      value={PerformanceData.strength}
                      onChange={handleperformanceData}
                      error={PerformanceData.strengthStatus === "error"}
                      success={PerformanceData.strengthStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      multiline
                      rows={5}
                    />
                    {PerformanceData.strengthStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Strength should be a minimum 20 characters maximum 500
                          characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Area of Improvements*
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="areaOfImprovements"
                      placeholder="eg. Area of Improvements"
                      value={PerformanceData.areaOfImprovements}
                      onChange={handleperformanceData}
                      error={
                        PerformanceData.areaOfImprovementsStatus === "error"
                      }
                      success={
                        PerformanceData.areaOfImprovementsStatus === "success"
                      }
                      disabled={togglePage.view === true ? true : false}
                      multiline
                      rows={5}
                    />
                    {PerformanceData.areaOfImprovementsStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Area of Improvements should be a minimum 20 characters
                          maximum 500 characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        FeedBack*
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="FeedBack"
                      placeholder="eg. Area of Improvements"
                      value={PerformanceData.FeedBack}
                      onChange={handleperformanceData}
                      error={PerformanceData.FeedBackStatus === "error"}
                      success={PerformanceData.FeedBackStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      multiline
                      rows={5}
                    />
                    {PerformanceData.FeedBackStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          FeedBack should be a minimum 20 characters maximum 500
                          characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your Performance data. This should not take much
                    time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={onDiscardPerformance}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={onEditPerformanceSubmit}
                  >
                    update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={
                    !checkAllFields() || pageState.state === "submitting"
                  }
                  onClick={handleAddPerformance}
                >
                  Submit
                </MaterialButton>
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};
export default AddPerformance;
